import { Container, Nav, Navbar } from "react-bootstrap";
import { Link } from "react-router-dom";
import { User } from "../../models/user";
import "./Navbar.scss";
import { useTranslation } from "react-i18next";
import NavBarLoggedInView from "./NavBarLoggedInView";
import NavBarLoggedOutView from "./NavBarLoggedOutView";
import { FaBars } from "react-icons/fa";

interface NavBarProps {
  loggedInUser: User | null;
  onSignedUpClicked: () => void;
  onLoginClicked: () => void;
  onLogoutSuccessful: () => void;
}

const NavBar = ({
  loggedInUser,
  onSignedUpClicked,
  onLoginClicked,
  onLogoutSuccessful,
}: NavBarProps) => {
  const { t } = useTranslation();

  return (
    <Navbar className="glass-navbar" expand="md" sticky="top">
      <Container>
        <Navbar.Brand as={Link} to="/" className="navbarLink">
          <img
            alt="Solvize logo"
            src="/images/logo/solvize-copper.svg"
            height="30"
            className="d-inline-block"
          />{" "}
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="main-navbar">
          <FaBars size={30} className="icon" />
        </Navbar.Toggle>
        <Navbar.Collapse id="main-navbar">
          <Nav>
            {loggedInUser && (
              <>
                <Nav.Link as={Link} to="/gameSets" className="navbarLink">
                  {t("pages.gameSets")}
                </Nav.Link>
                <Nav.Link as={Link} to="/badges" className="navbarLink">
                  {t("pages.badges")}
                </Nav.Link>
                <Nav.Link as={Link} to="/leaderboard" className="navbarLink">
                  {t("pages.leaderboard")}
                </Nav.Link>
                <Nav.Link as={Link} to="/store" className="navbarLink">
                  {t("pages.store")}
                </Nav.Link>
              </>
            )}
          </Nav>
          <Nav className="ms-auto">
            {loggedInUser ? (
              <NavBarLoggedInView
                currentUser={loggedInUser}
                onLogoutSuccessful={onLogoutSuccessful}
              />
            ) : (
              <NavBarLoggedOutView
                onLogInClicked={onLoginClicked}
                onSignUpClicked={onSignedUpClicked}
              />
            )}
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default NavBar;
